/* =======================================================
   Custom Card Carousel Script for C01 Page
   Developed by 8 Dotz Design LLC
   Date: 2025-09-17
   ======================================================= */
(function(){
  const viewport = document.querySelector('#page_c01_card-carousel .page_c01_card-carousel__viewport');
  if(!viewport) return;

  let isDown = false;
  let startX = 0;
  let startScrollLeft = 0;

  let lastX = 0;
  let lastT = 0;
  let velocity = 0;
  let rafId = null;

  const MAX_VELOCITY = 2.2;
  const DECAY_PER_MS = 0.0018;
  const MIN_V = 0.02;

  function cancelInertia(){
    if(rafId){
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function onPointerDown(e){
    if(e.pointerType && e.pointerType !== 'mouse') return;
    isDown = true;
    viewport.style.scrollSnapType = 'none';
    viewport.setPointerCapture?.(e.pointerId);

    startX = e.clientX;
    startScrollLeft = viewport.scrollLeft;
    lastX = startX;
    lastT = performance.now();
    velocity = 0;
    cancelInertia();
  }

  function onPointerMove(e){
    if(!isDown) return;
    const now = performance.now();
    const x = e.clientX;
    viewport.scrollLeft = startScrollLeft - (x - startX);

    const dt = Math.max(1, now - lastT);
    velocity = (x - lastX) / dt;
    velocity = Math.max(Math.min(velocity, MAX_VELOCITY), -MAX_VELOCITY);

    lastX = x;
    lastT = now;
    e.preventDefault();
  }

  function easeOutInertia(tPrev, v){
    const step = (t)=>{
      const dt = t - tPrev;
      tPrev = t;
      v *= Math.exp(-DECAY_PER_MS * dt);
      if(Math.abs(v) < MIN_V){
        viewport.style.scrollSnapType = 'x proximity';
        rafId = null;
        return;
      }
      viewport.scrollLeft -= v * dt;

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if(viewport.scrollLeft <= 0 || viewport.scrollLeft >= maxScroll){
        viewport.style.scrollSnapType = 'x proximity';
        rafId = null;
        return;
      }
      rafId = requestAnimationFrame(step);
    };
    rafId = requestAnimationFrame(step);
  }

  function onPointerUp(){
    if(!isDown) return;
    isDown = false;
    if(Math.abs(velocity) > MIN_V){
      easeOutInertia(performance.now(), velocity);
    }else{
      viewport.style.scrollSnapType = 'x proximity';
    }
  }

  viewport.addEventListener('pointerdown', onPointerDown);
  viewport.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  viewport.querySelectorAll('img').forEach(img=>{
    img.addEventListener('dragstart', e=>e.preventDefault());
  });
})();
